// A 'note' is a freeform line item (e.g. "delivery only") that has no pricing.
// Identify it by its SKU prefix 'note-' (notes are created with SKUs like 'note-1'),
// NOT by the word 'note' appearing in the product name — that wrongly matched real
// catalog products such as "Note Boat" (PGBFM-1806) and hid their price cells.
export const isNote = ({playground_boss_sku}) => {
    return playground_boss_sku ? /^note-/i.test(playground_boss_sku) : false;
};
